module.exports = __webpack_public_path__ + "static/scene2-6a1f5adc471a38bb45314a5dac3a665c.png";